import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getUserById, updateUser } from '../api/usersApi';
import { getProfesionLabel, getProfesionValue } from '../model/userConstants';

export const useUserProfile = ({ redirectTo }) => {
  const navigate = useNavigate();
  const userId = localStorage.getItem('id');
  const [firstname, setFirstname] = useState('');
  const [lastname, setLastname] = useState('');
  const [email, setEmail] = useState('');
  const [profesional, setProfesional] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [originalValues, setOriginalValues] = useState({});
  const [isEditing, setIsEditing] = useState(false);
  const [openGood, setOpenGood] = useState(false);
  const [openError, setOpenError] = useState(false);

  useEffect(() => {
    if (!userId) return;
    getUserById(userId)
      .then((data) => {
        setFirstname(data.firstname);
        setLastname(data.lastname);
        setEmail(data.email);
        setProfesional(getProfesionLabel(data.profesional));
      })
      .catch((error) => {
        console.error('Error fetching user data:', error);
      });
  }, [userId]);

  const handleEdit = () => {
    setOriginalValues({ firstname, lastname, email, profesional });
    setIsEditing(true);
  };

  const handleCancel = () => {
    setFirstname(originalValues.firstname);
    setLastname(originalValues.lastname);
    setEmail(originalValues.email);
    setProfesional(originalValues.profesional);
    setNewPassword('');
    setConfirmPassword('');
    setIsEditing(false);
  };

  const handleSave = async () => {
    if (newPassword !== confirmPassword) {
      setOpenError(true);
      return;
    }

    try {
      await updateUser({
        userId,
        payload: {
          firstname,
          lastname,
          email,
          profesional: getProfesionValue(profesional),
          password: newPassword,
        },
      });
      setOpenGood(true);
      setIsEditing(false);
      navigate(redirectTo);
    } catch (error) {
      console.error('Error saving changes:', error);
    }
  };

  return {
    firstname,
    setFirstname,
    lastname,
    setLastname,
    email,
    setEmail,
    profesional,
    setProfesional,
    newPassword,
    setNewPassword,
    confirmPassword,
    setConfirmPassword,
    isEditing,
    openGood,
    setOpenGood,
    openError,
    setOpenError,
    handleEdit,
    handleCancel,
    handleSave,
  };
};
